import { PaginatedEnvelope, ServiceResult } from "./api";

// Muscle Group interface
export interface MuscleGroup {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  pivot?: {
    exercise_id: number;
    muscle_group_id: number;
    type: "primary" | "secondary";
    created_at: string;
    updated_at: string;
  };
}

// Muscle Group assignment input
export interface MuscleGroupAssignment {
  muscle_group_id: number;
  type: "primary" | "secondary";
}

// Training method enum
export enum TrainingMethod {
  WEIGHT = "weight",
  RESISTANCE_BAND = "resistance_band",
  TIMED = "timed",
}

// Exercise body type enum
export enum ExerciseBodyType {
  UPPER_BODY = "Upper Body",
  LOWER_BODY = "Lower Body",
}

// Exercise interface
export interface Exercise {
  id: number;
  name: string;
  is_at_home: boolean;
  is_gym_based: boolean;
  yt_link: string | null;
  target_muscle_group: string | null;
  description: string | null;
  admin_note: string | null;
  training_method: TrainingMethod;
  type: string;
  created_at: string;
  updated_at: string;
  training_programs?: TrainingProgram[];
  primary_muscle_groups?: MuscleGroup[];
  secondary_muscle_groups?: MuscleGroup[];
  pivot?: {
    exercise_id: number;
    training_program_id: number;
    created_at: string;
    updated_at: string;
  };
}

// Training Program interface (simplified for exercise relationships)
export interface TrainingProgram {
  id: number;
  name: string;
  program_type: string;
  difficulty_level: string[];
  duration_weeks: number;
  training_days_per_week: number;
  start_date: string;
  end_date: string;
  workout_duration: string;
  created_by_id: number | null;
  is_admin: boolean;
  description: string | null;
  created_at: string;
  updated_at: string;
  parent_program_id: number | null;
  pivot?: {
    exercise_id: number;
    training_program_id: number;
    created_at: string;
    updated_at: string;
  };
}

// Create exercise input interface (for forms)
export interface CreateExerciseInput {
  name: string;
  is_at_home: boolean;
  is_gym_based: boolean;
  training_method: TrainingMethod;
  type: string;
  yt_link?: string;
  target_muscle_group?: string;
  description?: string;
  admin_note?: string;
  muscle_groups?: MuscleGroupAssignment[];
}

// Update exercise input interface (for editing)
export interface UpdateExerciseInput {
  name?: string;
  is_at_home?: boolean;
  is_gym_based?: boolean;
  training_method?: TrainingMethod;
  type?: string;
  yt_link?: string;
  target_muscle_group?: string;
  description?: string;
  admin_note?: string;
  muscle_groups?: MuscleGroupAssignment[];
}

// Exercise filters for searching/filtering
export interface ExerciseFilters {
  search?: string;
  is_at_home?: boolean;
  is_gym_based?: boolean;
  target_muscle_group?: string;
}

// Laravel pagination response structure for exercises
export type ExercisesApiResponse = PaginatedEnvelope<Exercise>;

// Exercises response for hook
export interface ExercisesResponse {
  exercises: Exercise[];
  total: number;
  page: number;
  limit: number;
}

export type ExerciseOperationResult = ServiceResult<Exercise>;

// PATCH /user-exercise-activity-logs/:id
export interface UpdateActivityLogInput {
  sets_data: Record<string, unknown>;
  is_persistent: boolean;
  rest_time_seconds?: number;
  rir?: number | null;
  rpe?: number | null;
  notes?: string | null;
}
